export const USER_ROLE_LABELS: Record<string, string> = {
  SUPERADMIN: 'Super Admin',
  SUPPORT: 'Suporte',
  FINANCE: 'Financeiro',
  SALES: 'Vendas',
};
